import { useMapStoreStateToClientState } from "./useMapStoreStateToClientState";
import { Store } from "@/stores";

export default function useStateOfFareCalendar(
  store: Store,
  isRoundTrip?: boolean,
) {
  return useMapStoreStateToClientState(store, (store) => {
    const pageStore = isRoundTrip
      ? store.appStore.stepByStepSearchPage.outbound
      : store.appStore.completeSearchPage;
    return {
      pricingMap: pageStore.fareCalendar.pricingMap,
      priceChange: pageStore.fareCalendar.priceChange,
      priceUp: pageStore.fareCalendar.priceUp,
      basePricingKey: pageStore.fareCalendar.basePricingKey,
      departureDateRange: pageStore.fareCalendar.departureDateRange,
      returnDateRange: pageStore.fareCalendar.returnDateRange,
      isPricingLoading: pageStore.fareCalendar.isLoading,
      isResultsLoading: pageStore.searchResults.isLoading,
      pricingCompleteness: pageStore.fareCalendar.pricingCompleteness,
      isCompleted: pageStore.searchResults.isCompleted,
      searchQuery: pageStore.searchQuery,
      language: store.appStore.config.language,
      pricingFilters: pageStore.fareCalendar.pricingFilters,
      isFareCalendarAvailable: pageStore.isFareCalendarAvailable,
      hasNoResults: pageStore.hasNoResults,
      filtersQuery: pageStore.filters.queryStr,
      resultsCheapestPrice:
        pageStore.sort?.topScoreItineraries?.cheapest?.itinerary?.totalPrice,
      resultsCheapestItinerary:
        pageStore.sort.topScoreItineraries?.cheapest?.itinerary,
      isFareCalendarFetched: pageStore.fareCalendar.isFetched,
      isRoundTrip: pageStore.searchResults.searchRequest.isRoundTrip,
      fareCalendar: pageStore.fareCalendar,
      fareCalendarQuery: pageStore.fareCalendar.fareCalendarQuery,
      fareCalendarBaseQuery: pageStore.fareCalendar.fareCalendarBaseQuery,
      hasMinDeparture: pageStore.fareCalendar.hasMinDeparture,
      hasMaxDeparture: pageStore.fareCalendar.hasMaxDeparture,
      hasMinReturn: pageStore.fareCalendar.hasMinReturn,
      lang: store.appStore.config.language,
      selectedKey:
        pageStore.fareCalendar.selectedKey ||
        pageStore.fareCalendar.basePricingKey,
      updatePricing: pageStore.fareCalendar.updatePricing,
      updateFareCalendarQuery: pageStore.fareCalendar.updateFareCalendarQuery,
      updateFareCalendarBaseQuery:
        pageStore.fareCalendar.updateFareCalendarBaseQuery,
      setSelectedKey: pageStore.fareCalendar.setSelectedKey,
      preserveCurrentFilters: isRoundTrip
        ? store.appStore.stepByStepSearchPage.preserveCurrentFilters
        : store.appStore.completeSearchPage.preserveCurrentFilters,
      isRestoringPreservedFilters:
        pageStore.filters.isRestoringPreservedFilters,
    };
  });
}
